import React from 'react'

import Grid, { Col } from '../../../../../components/pdf/Grid'
import Image from '../../../../../components/pdf/Image'
import Bar from '../../../../../components/pdf/Bar'
import Separator from '../../../../../components/pdf/Separator'

const Header = () => (
  <>
    <Grid justify="space-between" align="center">
      <Col>
        <Image src="/pdfs/allarmi/logo-allarmi.png" maxWidth={150} ignoreFixedSize />
      </Col>
    </Grid>
    <Separator weight={4} />
    <Bar />
  </>
)

export default Header
